import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";

import { IInventoryTaxListResponseData } from "@/api_framework/api_modals/Inventory";
import ToggleWithIcon from "@/app/components/ui/Toggles/ToggleWithIcon";
import { useInventoryTaxDetailsAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryTaxDetailsAPI";
import { useInventoryTaxListAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryTaxListAPI";
import { useInventoryTaxUpdateAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryTaxUpdateAPI";
import { setTaxDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";

const TaxtActiveDeactiveComponent = (props) => {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [openFlage, setOpenFlage] = useState(props?.flage);

  const dispatch = useDispatch();

  const { taxDetails, execute: fetchTaxDetailsAPI } = useInventoryTaxDetailsAPI();
  const { execute: updateTaxDetais } = useInventoryTaxUpdateAPI();
  const fetchTaxList = useInventoryTaxListAPI();

  const handelClick = () => {
    const constructedBody: IInventoryTaxListResponseData = {
      hsn_code: taxDetails?.hsn_code,
      cgst_percentage: taxDetails?.cgst_percentage,
      igst_percentage: taxDetails?.igst_percentage,
      sgst_percentage: taxDetails?.sgst_percentage,
      ugst_percentage: taxDetails?.ugst_percentage,
      status: taxDetails?.status ? false : true,
    };
    updateTaxDetais(constructedBody, props?.taxId).then(() => {
      fetchTaxList();
      setOpen(false);
    });
  };

  const handelToggle = () => {
    setOpen(false);
    setOpenFlage(props?.flage);
  };

  useEffect(() => {
    setOpenFlage(props?.flage);
  }, [props?.flage]);

  useEffect(() => {
    if (open) {
      fetchTaxDetailsAPI(props?.taxId);
    } else {
      dispatch(setTaxDetails({ data: null }));
    }
  }, [open]);

  return (
    <div>
      <div className="">
        <ToggleWithIcon
          toggleState={openFlage}
          forced
          onToggleChange={() => {
            setOpen(!open);
          }}
        />
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block  align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <span className="flex justify-end ml-6 cursor-pointer" onClick={() => setOpen(false)}>
                    <XMarkIcon className="h-5 w-5" />
                  </span>
                  <h3 className="text-sm text-[#000] font-medium mb-1 flex justify-between">
                    {`Are you sure you want to ${props?.flage ? "deactivate" : "activate"} the tax type ?`}
                  </h3>
                  <div className="flex gap-4 mt-6 justify-end">
                    <button
                      type="button"
                      onClick={() => handelToggle()}
                      className="text-xs mt-3 inline-flex w-full justify-center rounded-md bg-[#808DA0] px-4 py-2 font-semibold text-white   ring-inset ring-gray-300 hover-bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      onClick={() => handelClick()}
                      className="text-xs mt-3 inline-flex w-full justify-center rounded-md bg-[#193A6A] px-4 py-2 font-semibold text-white   ring-inset ring-gray-300 hover-bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default TaxtActiveDeactiveComponent;
